const baseUrl = "ResultVerification";

export const generateVerificationInvoiceUrl = () =>
	`${baseUrl}/generate-verification-invoice`;

export const getVerificationInvoiceData = (rrr) =>
	`${baseUrl}/verification-invoice-data?rrr=${rrr}`;

export const getVerificationRequestsUrl = ({ examinationBodyId, regNumber }) =>
	`${baseUrl}/requests?examinationBodyId=${examinationBodyId}&regNumber=${regNumber}`;
